<template>
  <!-- Circle: always visible, resizes smoothly via width/height transition. -->
  <div
    class="cursor-circle"
    :class="[`circle-size-${currentState}`, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
    :style="containerStyle"
  />

  <!-- Arrow overlay: fades in on top of the circle. mix-blend-mode: difference
       on the circle inverts the page — the arrow sits above and is also inverted,
       so it reads as the original page color (same technique as Blurred). -->
  <template v-for="state in iconStates" :key="`icon-${state.name}`">
    <InlineSvg
      v-if="state.svg?.layer1"
      :src="state.svg.layer1"
      class="cursor-overlay-icon"
      :class="[{ active: currentState === state.name }, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
      :style="containerStyle"
    />
  </template>
</template>

<script>
export default { name: 'CursorArrow' };
</script>

<script setup>
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { useCursorState } from './useCursorState.js';
import { getCursorSvg as getSharedCursorSvg } from '../../../utilities/useCursorSvg.js';

const { currentState, containerStyle, isOverIframe, isOutsideWindow } = useCursorState();

function getCursorSvg(state) {
  return getSharedCursorSvg('ARROW', state);
}

const iconStates = computed(() => [
  { name: 'hover',   svg: getCursorSvg('hover') },
  { name: 'project', svg: getCursorSvg('project_hover') },
].filter(s => s.svg));
</script>

<style scoped lang="scss">
@import './cursor-shared';

// project size defined in shared
</style>
